import { render } from "./currency-table.vue?vue&type=template&id=d922246e&ts=true"
import script from "./currency-table.ts?vue&type=script&lang=ts"
export * from "./currency-table.ts?vue&type=script&lang=ts"

import "./currency-table.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__